export default function() {
  return new Worker(__webpack_public_path__ + "static/js/MapsContainer-worker.f2d41130.worker.js");
}
